import { Button } from '@mui/material'
import UserDropdown from './UserDropdown'
import { Fragment, useEffect } from 'react'
import { Sun, Moon } from 'react-feather'
import { useDispatch } from 'react-redux'
import { NavItem, NavLink } from 'reactstrap'
import './NavbarUser.scss'
import { Link } from 'react-router-dom'


const NavbarUser = props => {
  const { skin, setSkin } = props
  const dispatch = useDispatch()

  function dispatchSkin() {
    dispatch({
      type: 'SET_THEME',
      data: {
        skin
      }
    })
  }

  useEffect(() => {
    if (skin !== 'light' && skin !== 'dark' && localStorage.getItem('skin')) {
      localStorage.getItem('skin') !== '"light"' && localStorage.getItem('skin') !== 'light' ? setSkin('dark') : setSkin('light');
    };
  }, []);

  useEffect(() => {
    dispatchSkin();
  }, [skin])

  const ThemeToggler = () => {
    if (skin === 'dark') {
      return <Sun className='ficon theme-image' onClick={() => setSkin('light')} />
    } else {
      return <Moon className='ficon theme-image' onClick={() => setSkin('dark')} />
    }
  }

  return (
    <div className=' navbar-nav align-items-center ml-auto d-flex'>
      {/* <Link to='/faq'>
        <Button variant="outlined" className="styleFaq">FAQ</Button>
      </Link> */}
      <ThemeToggler />
      <UserDropdown />
    </div>
  )
}
export default NavbarUser
